import React from 'react';
import './LegalStyles.css';

const PrivacyPolicy = () => {
  return (
    <div className="legal-container">
      <div className="legal-content">
        <h1 className="legal-title">奇迹妙审 - 隐私政策</h1>
        <p className="legal-date">最后更新日期: {new Date().toISOString().split('T')[0]}</p>
        
        <div className="legal-section">
          <h2>1. 引言</h2>
          <p>奇迹妙审（"我们"、"我们的"或"本公司"）尊重并保护您的隐私。本隐私政策旨在说明我们如何收集、使用、存储和分享您的信息，以及您可以如何访问、更新、控制和保护您的信息。</p>
          <p>请您在使用我们的服务前仔细阅读本隐私政策。如果您不同意本隐私政策中的任何内容，您应立即停止使用我们的服务。</p>
        </div>
        
        <div className="legal-section">
          <h2>2. 信息收集</h2>
          <p>2.1 您提供的信息：</p>
          <ul>
            <li>账户信息：当您注册账户时，我们可能会收集您的姓名、电子邮件地址、电话号码、公司名称等信息。</li>
            <li>交易信息：当您使用我们的付费服务时，我们会收集必要的支付和账单信息。</li>
            <li>内容数据：您上传到我们平台用于内容审核和管理的文本、图像、视频或其他媒体。</li>
            <li>通信数据：您与我们的客户支持团队交流的内容。</li>
          </ul>
          
          <p>2.2 自动收集的信息：</p>
          <ul>
            <li>使用数据：我们可能会自动收集有关您如何使用我们服务的信息，例如访问时间、使用的功能、浏览的页面和点击的链接。</li>
            <li>设备信息：我们可能会收集有关您使用的设备的信息，例如IP地址、设备类型、操作系统版本和浏览器类型。</li>
            <li>Cookies和类似技术：我们使用cookies和类似技术来收集关于您使用我们服务的信息。</li>
          </ul>
        </div>
        
        <div className="legal-section">
          <h2>3. 信息使用</h2>
          <p>我们可能将收集到的信息用于以下目的：</p>
          <ul>
            <li>提供、维护和改进我们的服务</li>
            <li>处理交易并发送相关通知</li>
            <li>提供客户支持和回应您的请求</li>
            <li>发送技术通知、更新、安全警报和支持消息</li>
            <li>进行研究和分析，以改进我们的服务</li>
            <li>保护我们和我们用户的合法权益</li>
            <li>检测和防止欺诈、滥用、安全风险和技术问题</li>
            <li>根据您的同意或适用法律允许的其他方式使用信息</li>
          </ul>
        </div>
        
        <div className="legal-section">
          <h2>4. 信息共享</h2>
          <p>我们可能在以下情况下与第三方共享您的信息：</p>
          <ul>
            <li>在您同意的情况下</li>
            <li>与我们的服务提供商和合作伙伴共享，他们代表我们执行服务或功能</li>
            <li>为遵守法律法规、法院命令或其他法律程序</li>
            <li>为保护我们或任何第三方的权利、财产或安全</li>
            <li>在公司交易（如合并、收购或资产出售）的情况下</li>
          </ul>
          <p>我们不会出售您的个人信息。</p>
        </div>
        
        <div className="legal-section">
          <h2>5. 数据安全</h2>
          <p>我们实施了适当的技术和组织措施，以保护您的个人信息免遭意外或非法破坏、丢失、更改、未经授权的披露或访问。然而，没有任何安全系统是绝对安全的，我们不能保证您的信息永远不会被未经授权的方式访问、披露、更改或破坏。</p>
        </div>
        
        <div className="legal-section">
          <h2>6. 数据保留</h2>
          <p>我们将保留您的个人信息，只要有必要实现本隐私政策中描述的目的，除非法律要求或允许更长的保留期限。当我们不再需要处理您的个人信息时，我们将删除或匿名化处理这些信息。</p>
        </div>
        
        <div className="legal-section">
          <h2>7. 您的权利</h2>
          <p>根据您所在地区的适用法律，您可能拥有以下权利：</p>
          <ul>
            <li>访问权：您有权了解我们处理的关于您的个人信息。</li>
            <li>更正权：您有权要求我们更正不准确或不完整的个人信息。</li>
            <li>删除权：在某些情况下，您有权要求我们删除您的个人信息。</li>
            <li>限制处理权：在某些情况下，您有权要求我们限制对您个人信息的处理。</li>
            <li>数据可携性权：您有权以结构化、常用和机器可读的格式接收您提供给我们的个人信息，并有权将这些信息传输给另一个控制者。</li>
            <li>反对权：在某些情况下，您有权反对我们处理您的个人信息。</li>
            <li>撤回同意权：如果我们基于您的同意处理个人信息，您有权随时撤回您的同意。</li>
          </ul>
          <p>如果您想行使这些权利中的任何一项，请联系我们。</p>
        </div>
        
        <div className="legal-section">
          <h2>8. 儿童隐私</h2>
          <p>我们的服务不面向16岁以下的儿童。我们不会故意收集16岁以下儿童的个人信息。如果您是父母或监护人，并且您认为您的孩子向我们提供了个人信息，请联系我们。</p>
        </div>
        
        <div className="legal-section">
          <h2>9. 第三方链接</h2>
          <p>我们的服务可能包含指向第三方网站或服务的链接，这些网站或服务不受我们的控制。我们对这些第三方的隐私做法不负责任，建议您查看他们的隐私政策。</p>
        </div>
        
        <div className="legal-section">
          <h2>10. 跨境数据传输</h2>
          <p>您的信息可能会传输到、存储在中国境内以及您居住地以外的国家或地区。我们将采取措施确保此类传输符合适用的数据保护法律，并且您的信息受到本隐私政策中描述的保护。</p>
        </div>
        
        <div className="legal-section">
          <h2>11. 政策更新</h2>
          <p>我们可能会不时更新本隐私政策。当我们进行重大更改时，我们将通过适当的方式通知您，例如在我们的网站上发布通知或发送电子邮件。建议您定期查看本隐私政策，以了解我们如何保护您的信息。</p>
        </div>
        
        <div className="legal-section">
          <h2>12. 联系我们</h2>
          <p>如果您对本隐私政策或我们的隐私做法有任何问题、意见或请求，请通过以下方式联系我们：</p>
          <p>电子邮件：service@giant-ads.com</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 